import { ReduceStore } from 'flux/utils';
import { Map } from 'immutable';
import moment from 'moment';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

function cleanUpRun(run) {
  const cleanRun = [run.id || 'TK',
    {
      id: run.id || 'TK',
      scenarioId: run.relationships.scenario.data.id,
      startedAt: moment(run.attributes.startedAt),
      finishedAt: moment(run.attributes.finishedAt),
      status: run.attributes.status,
    }];
  return cleanRun;
}

class CrossChannelRunStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  reduce(state, action) {
    switch (action.actionType) {
      // case Constants.CrossChannel.RUNS_RECEIVED:
        // return this.getState().merge(new Map(action.runs.map(cleanUpRun)));
      case Constants.CrossChannel.SCENARIOS_RECEIVED:
        return this.getState().merge(new Map(action.runs.map(cleanUpRun)));
      case Constants.CrossChannel.RUN_SUBMITTED:
        return this.getState()
          .merge(new Map([action.runs].map(cleanUpRun)));
      default:
        return state;
    }
  }

  getRuns() {
    return this.getState();
  }
}

const instance = new CrossChannelRunStore(AppDispatcher);
export default instance;
